import { useEffect, type RefObject } from 'react';

/**
 * Calls `onLoadMore` when the end of the list scrolls into view.
 *
 * @param {RefObject<HTMLElement>} sentinelRef an empty row after the last row, marking the end of the list
 * @param {boolean} enabled watch only while true, e.g. `hasMore && !loading`
 * @param {() => void} onLoadMore fetches the next page
 */
export function useLoadMoreOnScroll (
  sentinelRef: RefObject<HTMLElement>,
  enabled: boolean,
  onLoadMore?: () => void
) {
  useEffect(() => {
    const sentinel = sentinelRef.current;
    if (!enabled || !sentinel) return undefined;

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) onLoadMore?.();
    });
    observer.observe(sentinel);
    return () => observer.disconnect();
  }, [sentinelRef, enabled, onLoadMore]);
}
